<template>
  <div>
    <div class="ligneRouge"></div>
    <v-img
      style="height: 100%; padding-top: 50px; padding-bottom: 50px"
      class="imageFond"
    >

      <div class="container">
        <v-row class="text-center">
          <v-col cols="12">
            <v-card
              class="rounded-0 pa-7"
              elevation="0"
              style="width: 100%; background-color: RGBA(255, 255, 255, 0.6)"
            >
              <div v-if="demandeContactStore.envoiReussi == false">
                <FaqPrincipale />

                <v-row class="py-2">
                  <v-col cols="12">
                    <h3>{{ $tc("demandeContact.titre") }}</h3>
                    <p>{{ $tc("demandeContact.messageHaut") }}</p>
                    <v-form
                      ref="form"
                      v-model="formValide"
                    >
                      <v-row class="mt-0">
                        <v-col
                          cols="12"
                          sm="8"
                          md="6"
                          class="middle"
                        >
                          <v-autocomplete
                            :items="inscriptionStore.listeCssMinimise"
                            v-model="demande.organismeSelectionne"
                            v-on:change="determinerTypeEleve()"
                            item-text="nom"
                            item-value="cssId"
                            return-object
                            :rules="rules.select"
                            dense
                            :label="
                              $t(
                                'Panier.SectionIdentificationEleve.OrganismeFrequente'
                              )
                            "
                            outlined
                          >
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row
                        class="mt-0"
                        v-if="EstCssExterneSelection"
                      >
                        <v-col
                          cols="12"
                          sm="8"
                          md="6"
                          class="middle"
                        >
                          <v-autocomplete
                            outlined
                            dense
                            :items="lstCssJson"
                            :rules="rules.select"
                            return-object
                            :item-text="(item) => item.nom"
                            v-model="demande.cssFrequente"
                            :label="
                              $t(
                                'Panier.SectionIdentificationEleve.CSSFrequente'
                              )
                            "
                          >
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row
                        class="mt-0"
                        v-if="
                          EstCssExterneSelection ||
                          (!estExterne && demande.organismeSelectionne != null)
                        "
                      >
                        <v-col
                          cols="12"
                          sm="8"
                          md="6"
                          class="middle"
                        >
                          <v-autocomplete
                            :label="
                              $t(
                                'Panier.SectionIdentificationEleve.EcoleFrequente'
                              )
                            "
                            :disabled="
                              demande.organismeSelectionne == null ||
                              (estExterne && demande.cssFrequente == null)
                            "
                            :rules="rules.select"
                            :items="filterEcolePublique"
                            :item-text="(item) => item.nom"
                            return-object
                            v-model="demande.ecoleFrequente"
                            outlined
                            dense
                          >
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row
                        class="mt-0"
                        v-if="EstEtablissementPriveSelection"
                      >
                        <v-col
                          cols="12"
                          sm="8"
                          md="6"
                          class="middle"
                        >
                          <v-autocomplete
                            :label="
                              $t(
                                'Panier.SectionIdentificationEleve.EtablissementFrequente'
                              )
                            "
                            v-model="demande.etablissementPrive"
                            :rules="rules.select"
                            :items="lstEcolesPriveesJson"
                            :item-text="(item) => item.nom"
                            outlined
                            return-object
                            dense
                          >
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col
                          class="middle"
                          cols="12"
                          sm="8"
                          md="6"
                        >
                          <v-text-field
                            dense
                            v-model="demande.courriel"
                            :rules="rules.courriel"
                            :label="$tc('demandeContact.courriel')"
                            outlined
                            hide-details="auto"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col
                          class=""
                          offset-md="3"
                          cols="12"
                          offset-sm="2"
                          sm="4"
                          md="3"
                        >
                          <v-text-field
                            dense
                            v-model="demande.nom"
                            :rules="rules.nom"
                            :label="$tc('demandeContact.nom')"
                            outlined
                            hide-details="auto"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col
                          class=""
                          cols="12"
                          sm="4"
                          md="3"
                        >
                          <v-text-field
                            dense
                            v-model="demande.prenom"
                            :rules="rules.prenom"
                            :label="$tc('demandeContact.prenom')"
                            outlined
                            hide-details="auto"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col
                          class="middle"
                          cols="12"
                          sm="8"
                          md="6"
                        >
                          <v-text-field
                            dense
                            v-model="demande.telephone"
                            v-mask="'(###) ###-####'"
                            :rules="rules.telephone"
                            :label="$tc('demandeContact.telephone')"
                            outlined
                            hide-details="auto"
                            placeholder="(###) ###-####"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col
                          class="middle"
                          cols="12"
                          sm="8"
                          md="6"
                        >
                          <v-text-field
                            dense
                            v-model="demande.objet"
                            :rules="rules.objet"
                            :label="$tc('demandeContact.objet')"
                            outlined
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col
                          class="middle"
                          cols="12"
                          sm="8"
                          md="6"
                        >
                          <v-textarea
                            dense
                            v-model="demande.message"
                            :rules="rules.message"
                            :label="$tc('demandeContact.message')"
                            :placeholder="$tc('demandeContact.messagePlaceholder')"
                            outlined
                            auto-grow
                          >
                          </v-textarea>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          class="middle"
                          cols="12"
                          offset-sm="4"
                          sm="8"
                          offset-md="6"
                          md="6"
                        >
                          <VueRecaptcha
                            :language="obtenirLangueCsqc"
                            v-on:verify="verifyCaptcha"
                            v-on:expired="expriredCaptcha"
                            :loadRecaptchaScript="true"
                            :sitekey="siteKey"
                            ref="reCaptcha"
                          >
                          </VueRecaptcha>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          class="pt-0 mt-0 middle"
                          v-if="captchaInfo.captchaMontrerMessageErreur"
                          cols="12"
                          sm="8"
                          md="6"
                        >
                          <label style="color: #ff5252;float:left;">
                            {{ $tc("demandeContact.captchaErreur") }}
                          </label>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    class="middle"
                    cols="12"
                    sm="6"
                  >
                    <v-divider
                      class=""
                      style="width: 100%"
                    ></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    class="boutonEnvoyerDiv middle"
                  >
                    <v-btn
                      v-on:click.stop="Envoyer()"
                      class="boutonEnvoyer"
                      :loading="demandeContactStore.chargement"
                    >{{ $tc("demandeContact.envoyer") }}</v-btn>
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <v-alert
                  type="success"
                  v-html="$tc('demandeContact.envoiReussi')"
                ></v-alert>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-img>
    <BoiteNousJoindre />
    <div class="petiteLigneRouge"></div>
  </div>
</template>

<script>
import FaqPrincipale from '@/components/Faq/FaqPrincipal.vue';
import useAppStore from '@/store/appStore';
import useInscriptionStore from '@/store/inscriptionStore';
import useDemandeContactStore from '@/store/demandeContactStore';
import VueRecaptcha from 'vue-recaptcha';
import csqcOutils from '@/outils/CSQCOutils';
import EleveInscriptionAjax from '@/services/EleveInscriptionAjax';
import { InscriptionExterne, TypeEleve } from '@/outils/Enum';
import BoiteNousJoindre from '../Accueil/BoiteNousJoindre.vue';
import cssJson from '../../assets/jsonSelectEcole/css.json';
import ecolesPriveesJson from '../../assets/jsonSelectEcole/ecolesPrivees.json';
import ecolesPubliquesJson from '../../assets/jsonSelectEcole/ecolesPubliques.json';

const racineLocalStorage = 'csqc_coursEte_';
const localStorageCssId = 'CSSId';
export default {
  name: 'DemandeContact',
  components: {
    FaqPrincipale,
    VueRecaptcha,
    BoiteNousJoindre,
  },
  props: {},
  setup() {
    const appStore = useAppStore();
    const inscriptionStore = useInscriptionStore();
    const demandeContactStore = useDemandeContactStore();

    return { appStore, inscriptionStore, demandeContactStore };
  },
  mounted() {
    // si jamais :loadRecaptchaScript="true" pour le captcha ne fonctionne pas utiliser le code ici.
    //  let recaptchaScript = document.createElement('script')
    //   recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
    //   document.head.appendChild(recaptchaScript)
  },
  created() {
    this.chargement = true;
    EleveInscriptionAjax.obtenirListeCssMinimise().then((data) => {
      this.inscriptionStore.listeCssMinimise = data;
      this.demande.organismeSelectionne =
        this.obtenirCssSelectionneLocalStorage;
      this.determinerTypeEleve();
    });
    this.chargement = false;
  },
  data() {
    return {
      formValide: true,
      chargement: false,
      lstCssJson: cssJson.sort((a, b) => a.nom.localeCompare(b.nom)),
      lstEcolesPriveesJson: ecolesPriveesJson.sort((a, b) => a.nom.localeCompare(b.nom)),
      lstEcolePubliquesJson: ecolesPubliquesJson.sort((a, b) => a.nom.localeCompare(b.nom)),
      captchaInfo: {
        captchaValide: false,
        captchaMontrerMessageErreur: false,
      },
      demande: {
        courriel: '',
        nom: '',
        prenom: '',
        typeEleve: 0,
        objet: '',
        telephone: '',
        message: '',
        organismeSelectionne: null,
        cssFrequente: null,
        ecoleFrequente: null,
        etablissementPrive: null,
        userAgent: null,
      },
      rules: {
        courriel: [
          (val) => ((val || '').length > 0 && (val || '').length <= 50) || this.$t('erreurs.CourrielInvalide'),
          (v) => !v || /.+@.+\..+/.test(v) || this.$tc('erreurs.CourrielInvalide'),
        ],
        nom: [
          (val) => ((val || '').length > 0 && (val || '').length <= 50) || this.$tc('demandeContact.nomRequis'),
        ],
        select: [
          (v) => v != null || v !== undefined || this.$t('erreurs.requis'),
        ],
        prenom: [
          (val) => ((val || '').length > 0 && (val || '').length <= 50) || this.$tc('demandeContact.prenomRequis'),
        ],
        objet: [
          (val) => ((val || '').length > 0 && (val || '').length <= 100) || this.$tc('demandeContact.objetRequis'),
        ],
        message: [
          (val) => ((val || '').length > 0 && (val || '').length <= 500) || this.$tc('demandeContact.messageRequis'),
        ],
        telephone: [
          (val) => (val || '').length > 0 ||
            this.$tc('demandeContact.telephoneRequis'),
          (val) => (val != null && val.length >= 14) || this.$tc('demandeContact.telephoneIncomplet'),
        ],
      },
    };
  },
  computed: {
    siteKey() {
      return this.appStore.modele.captchaSiteKey;
    },
    obtenirLangueCsqc() {
      return csqcOutils.GetLangue();
    },
    filterEcolePublique() {
      if (this.estExterne) {
        if (this.demande.cssFrequente != null) {
          return this.lstEcolePubliquesJson.filter(
            (x) => x.cssId === this.demande.cssFrequente.id,
          );
        } return [];
      } if (this.demande.organismeSelectionne != null) {
        return this.lstEcolePubliquesJson.filter(
          (x) => x.cssId === this.demande.organismeSelectionne.organisme,
        );
      }
      return [];
    },
    EstCssExterneSelection() {
      const cssIdLocalStorage = localStorage.getItem(
        racineLocalStorage + localStorageCssId,
      );
      if (cssIdLocalStorage != null || cssIdLocalStorage !== '') {
        if (this.demande.organismeSelectionne == null) {
          if (cssIdLocalStorage === InscriptionExterne.CssIdAutreCSS) {
            return true;
          }
          return false;
        }
        if (
          this.demande.organismeSelectionne.cssId ===
          InscriptionExterne.CssIdAutreCSS
        ) {
          return true;
        }
        return false;
      }
      return false;
    },
    obtenirCssSelectionneLocalStorage() {
      const cssIdLocalStorage = localStorage.getItem(
        racineLocalStorage + localStorageCssId,
      );

      const resultat = this.inscriptionStore.listeCssMinimise.find(
        (x) => x.cssId === cssIdLocalStorage,
      );
      if (resultat != null) {
        return resultat;
      }
      return null;
    },

    EstEtablissementPriveSelection() {
      const cssIdLocalStorage = localStorage.getItem(
        racineLocalStorage + localStorageCssId,
      );
      if (cssIdLocalStorage != null || cssIdLocalStorage !== '') {
        if (this.demande.organismeSelectionne == null) {
          if (cssIdLocalStorage === InscriptionExterne.CssIdEcolePrive) {
            return true;
          }
          return false;
        }
        if (
          this.demande.organismeSelectionne.cssId ===
          InscriptionExterne.CssIdEcolePrive
        ) {
          return true;
        }
        return false;
      }
      return false;
    },
    estExterne() {
      if (this.demande.organismeSelectionne != null) {
        if (
          this.demande.organismeSelectionne.cssId ===
          InscriptionExterne.CssIdAutreCSS ||
          this.demande.organismeSelectionne.cssId ===
          InscriptionExterne.CssIdEcolePrive
        ) {
          return true;
        }
        return false;
      }
      return false;
    },
  },
  methods: {
    verifyCaptcha() {
      this.captchaInfo.captchaValide = true;
      this.captchaInfo.captchaMontrerMessageErreur = false;
    },
    expriredCaptcha() {
      this.captchaInfo.captchaValide = false;
    },
    determinerTypeEleve() {
      if (this.demande.organismeSelectionne == null) {
        this.demande.typeEleve = TypeEleve.Inconnu;
        return;
      }

      if (
        this.demande.organismeSelectionne.cssId ===
        InscriptionExterne.CssIdAutreCSS
      ) {
        this.demande.typeEleve = TypeEleve.AutreCSS;
      } else if (
        this.demande.organismeSelectionne.cssId ===
        InscriptionExterne.CssIdEcolePrive
      ) {
        this.demande.typeEleve = TypeEleve.EcolePrive;
      } else {
        this.demande.typeEleve = TypeEleve.Membre;
      }
    },
    Envoyer() {
      this.$refs.form.validate();

      if (this.captchaInfo.captchaValide === false) {
        this.captchaInfo.captchaMontrerMessageErreur = true;
      } else {
        this.captchaInfo.captchaMontrerMessageErreur = false;
      }

      if (this.formValide === false || this.captchaInfo.captchaValide === false) {
        return;
      }
      this.demande.userAgent = navigator.userAgent;

      this.demandeContactStore.envoyer(this.demande);
    },
  },
};
</script>

<style scoped>
.boutonEnvoyerDiv {
  text-align: right;
  margin-top: 1em;
}

.middle {
  margin-left: auto;
  margin-right: auto;
}

.boutonEnvoyer {
  background-color: #095797 !important;
  border-color: #095797 !important;
  color: white !important;
  min-height: 48px !important;
}
</style>
